<script>
  export let workoutPlan = {
    title: '',
    description: '',
    visibility: 'private',
  }
  export let submitLabel
  export let saving = false

  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  function handleOnSubmit() {
    dispatch('save', {
      title: workoutPlan.title,
      description: workoutPlan.description,
      visibility: workoutPlan.visibility,
    })
  }
</script>

<form on:submit|preventDefault={handleOnSubmit}>
  <div class="mb-3 row">
    <label class="col-sm-2 col-form-label" for="title">Title</label>
    <div class="col-sm-10">
      <input
        type="text"
        class="form-control"
        name="title"
        id="title"
        bind:value={workoutPlan.title}
      />
    </div>
  </div>
  <div class="mb-3 row">
    <label class="col-sm-2 col-form-label" for="description">Description</label>
    <div class="col-sm-10">
      <textarea
        class="form-control"
        name="description"
        rows="3"
        id="description"
        bind:value={workoutPlan.description}
      />
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-sm-2" />
    <div class="col-sm-10">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="visibility"
          value="private"
          id="visibility_private"
          bind:group={workoutPlan.visibility}
        />
        <label class="form-check-label" for="visibility_private">
          Private Plan
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="visibility"
          value="public"
          id="visibility_public"
          bind:group={workoutPlan.visibility}
        />
        <label class="form-check-label" for="visibility_public">
          Public Plan
        </label>
      </div>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-sm-2" />
    <div class="col-sm-10">
      <button type="submit" class="btn btn-primary">
        {#if saving}
          <div class="spinner-border spinner-border-sm" role="status" />
        {/if}
        {submitLabel}</button
      >
    </div>
  </div>
</form>
